import { API_BASE_URL } from "../../config"

export default function Invoice({ bookingId }) {
    const downloadInvoice = async (bookingId) => {
        const res = await fetch(
            `${API_BASE_URL}/bookings/invoice/${bookingId}`,
        );

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `invoice-${bookingId}.pdf`;
        document.body.appendChild(a);
        a.click();

        a.remove();
        window.URL.revokeObjectURL(url);
    };

    return (
        <button onClick={() => downloadInvoice(bookingId)}>
            Download Invoice
        </button>
    )
}